<template>
	<div>
		<!-- 高级查询 -->
		<minhead :headtitle="headtitle"></minhead>
		
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
				<div class="addstyle" style="width: 100px;" @click='excelExport'>
					<samp>
					导出
					<i class="el-icon-upload2 el-icon--right"></i>
					</samp>
				</div>
				<!-- <el-button type="primary" plain=""  @click="excelExport"  style="width: 100px;">
					导出
					<i class="el-icon-upload2 el-icon--right"></i>
				</el-button> -->
				
				</div>
				<div class="Centerupdown " >
					<div class="Centerupdown otherchoose">
					<el-select v-model="serchform.faplxdm" style="width: 140px;" @change="changeFrom">
						<el-option label="电子普票" value="026"></el-option>
						<el-option label="电子专票" value="028"></el-option>
					</el-select>

				</div>
					<el-date-picker
							v-model="serchform.time"
							type="monthrange"
							range-separator="至"
							start-placeholder="开始月份"
							value-format="yyyy-MM"
							end-placeholder="结束月份" @change="changeFrom">
					</el-date-picker>
					<el-dropdown :hide-on-click="false">
					  <span class="el-dropdown-link">
					  <div class="aftericon" style="margin-right: 16px;"><img  src="../../../assets/img/iconshai.png" /></div>
					  </span>
					  <el-dropdown-menu slot="dropdown" >
						    <el-checkbox-group v-model="checkmeauList">
						     <el-dropdown-item  v-for="item in meaulist" ><el-checkbox :label="item" :key="item" @change="clickTitle()">{{item}}</el-checkbox></el-dropdown-item>
						    </el-checkbox-group>
					   
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
				<el-table :data="tableData"  border style="width: 100%"  height="calc(100vh - 202px )" ref="multipleTable">
					<el-table-column prop="item.faplxdm" label="发票类型" align="center" :formatter="this.rowtofapiao"></el-table-column>
					<el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
					<el-table-column prop="sum" label="合计" align="center"></el-table-column>
					<el-table-column v-if="datatitle[0].istrue" prop="shuil_0"  label="0%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[1].istrue" prop="shuil_3"  label="3%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[2].istrue" prop="shuil_5"  label="5%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[3].istrue" prop="shuil_6"  label="6%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[4].istrue" prop="shuil_10" label="10%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[5].istrue" prop="shuil_11" label="11%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[6].istrue" prop="shuil_13" label="13%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[7].istrue" prop="shuil_16" label="16%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[8].istrue" prop="shuil_17" label="17%"  align="center"></el-table-column>
					<el-table-column v-if="datatitle[9].istrue" prop="shuil_99" label="其他"  align="center"></el-table-column>

				</el-table>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import https from "../../../../https";
import axios from "axios";

export default {
	components: {},
	data() {
		return {
			checkmeauList: ["0%","17%","16%","13%","11%","10%", "6%","5%","3%","其他"],
			meaulist: ["0%","17%","16%","13%","11%","10%", "6%","5%","3%","其他"],
			checkHeadFiled:["shuil_0","shuil_3","shuil_5","shuil_6","shuil_10","shuil_11","shuil_13","shuil_16","shuil_17","shuil_99"],
			datatitle:[
				{prop:"shuil_0"  ,label:"0%",istrue: true},
				{prop:"shuil_3"  ,label:"3%",istrue: true},
				{prop:"shuil_5"  ,label:"5%",istrue: true},
				{prop:"shuil_6"  ,label:"6%",istrue: true},
				{prop:"shuil_10" ,label:"10%",istrue: true},
				{prop:"shuil_11" ,label:"11%",istrue: true},
				{prop:"shuil_13" ,label:"13%",istrue: true},
				{prop:"shuil_16" ,label:"16%",istrue: true},
				{prop:"shuil_17" ,label:"17%",istrue: true},
				{prop:"shuil_99" ,label:"其他",istrue: true}
			],
			serchform:{},
			faplxdmStr:"",
			tableData: [
			],
			headtitle: ['统计报表', '发票资料统计'],
			tableHeight:""
		};
	},
	created() {},
	mounted() {
		 this.$nextTick(() =>{
			this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			window.onresize = () =>{
		    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
		      }
		    })
	},
	methods: {
		changeFrom(){
			if (!this.checkParam(false)){
				return;
			}
			if (this.serchform.faplxdm=="026"){
				this.faplxdmStr="电子普票";
			}else if (this.serchform.faplxdm=="028"){
				this.faplxdmStr="电子专票";
			}

			let param =JSON.parse(JSON.stringify(this.serchform));
			param.time=this.getMonthBetween(this.serchform.time[0],this.serchform.time[1]);
			console.log(param.time);
			this.$https.fetchPost("doc/getCxtjInfo",param).then(res => {
				this.total = res.data.obj.total;
				// console.log(this.total)
				this.tableData = res.data.obj.rows;
			});

		},
		getMonthBetween(start,end){
			let result = [];
			let s = start.split("-");
			let e = end.split("-");
			let min = new Date();
			let max = new Date();
			min.setFullYear(s[0],s[1]);
			max.setFullYear(e[0],e[1]);
			let curr = min;
			while(curr <= max){
				console.log(curr.getFullYear());
				let month = curr.getMonth();
				let str=curr.getFullYear()+""+(month);
				let s=curr.getFullYear()+"0";
				if(str==s){
					str=(curr.getFullYear()-1)+"12";
				}
				str=str.length==6?str:str.substring(0,4)+"0"+str.substring(4,5);
				result.push(str);
				curr.setMonth(month+1);
			}
			return result.toString();
		},
		clickTitle(){
			this.datatitle=JSON.parse(JSON.stringify(this.datatitle).replace(/true/g, 'false'));
			console.log(this.checkmeauList);
			for (let i=0;i<this.checkmeauList.length;i++){
				this.datatitle.find(item => item.label == this.checkmeauList[i]).istrue=true
			}
			this.getheadFiled();
		},
		excelExport(){
			if (!this.checkParam(true)){
				return;
			}
			let url = this.$https.baseURL+"excel/getInvoicestatisticsExcel"; //请求下载文件的地址
			let token=localStorage.getItem('token')
			let param=JSON.parse(JSON.stringify(this.serchform));
			param.pagenum = this.pagenum;
			param.page = this.page;
			param.serchval=this.serchval;
			if (param.kaiprq){
				param.kaiprq=param.kaiprq[0]+","+param.kaiprq[1];
			}
			param.headTitle=this.checkmeauList;
			param.headFiled=this.checkHeadFiled.toString();
			if(token != "" & token !=null){
				axios.defaults.headers.common['token']=token
			}
			axios.post(url,param,{responseType:"blob"})
					.then(res => {
						if (!res) return;
                        let blob = new Blob([res.data], {
                            type: "blob"
                        });
                        let url = window.URL.createObjectURL(blob);
                        let aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "发票资料统计.xls"); // 下载的文件
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink);
                        window.URL.revokeObjectURL(url);
						/*let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
						let objectUrl = URL.createObjectURL(blob);
						window.location.href = objectUrl;*/

					})
					.catch(error => {
						this.$message.error(error);
					});

		},
		getheadFiled(){
			this.checkHeadFiled=[];
			for (let j=0;j<this.datatitle.length;j++){
				for (let i=0;i<this.checkmeauList.length;i++){
					if (this.checkmeauList[i]==this.datatitle[j].label){
						this.checkHeadFiled[j]=this.datatitle[j].prop;
					}
				}
			}
		},
		checkParam(ifMsg){
			if (ifMsg){
				 if (!this.serchform.time){
					this.$message.warning("发票类型、查询类型、统计月份");
					return false;
				}else if (!this.serchform.faplxdm){
					this.$message.warning("发票类型、查询类型、统计月份");
					return false;
				}else{
					return true;
				}
			}else{
				if ( this.serchform.time && this.serchform.faplxdm){
					return true;
				}else{
					return false;
				}
			}


		}
	}
};
</script>

<style scoped="scoped" lang="less">
	
.otherchoose /deep/.el-input__inner {
	color: #0080ff;
	border: 1px solid #0080ff;
}
.otherchoose/deep/.el-icon-arrow-up:before {
	color: #0080ff;
}
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}

	
	/deep/.el-dialog__header {
		display: none;
	}
.areatable {
	margin-top: 27px;
}
.aftericon:extend(.Centerhorizontally) {
	width: 36px;
	height: 33px;
	background: #ffffff;
	box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
	opacity: 1;
	border-radius: 3px;
	margin-left: 20px;
}
.aftericon > img {
	width: 16px;
	height: 16px;
}
.areacontent {
	margin-left: 21px;
}
</style>
